<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="left">
        <el-image
          @click="goHome"
          class="logo-img"
          :src="channelByCode.channelLogo"
          v-if="channelByCode && channelByCode.channelLogo"
        ></el-image>
        <el-image @click="goHome" class="logo-img" :src="logoUrl" v-else></el-image>

        <!-- <img @click="goHome"
          :src="logoUrl"
          alt="logo"
          :style="taizhouFlag ? 'width: 274px;' : 'width: 408px;'"
          style="cursor: pointer;"
        > -->
      </div>
      <div class="right">
        <div class="recruit" v-if="!code" @click="toPartner">
          <el-button v-if="!taizhouFlag && !huangyanFlag && !haishuFlag">生态伙伴专区</el-button>
          <el-button v-if="taizhouFlag">应用开发指南</el-button>
          <el-button v-if="huangyanFlag">开发规范文档</el-button>
          <el-button v-if="haishuFlag">开放平台</el-button>
        </div>
        <div v-if="userInfo" class="recruit">
          <el-dropdown @command="handleTownSwitch" @visible-change="dropDownVisible">
            <a>
              {{ townName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </a>
            <el-dropdown-menu class="search-dropdown-menu" slot="dropdown">
              <el-input
                placeholder="搜索"
                prefix-icon="el-icon-search"
                clearable
                @input="searchTownname"
                v-model="searchtown"
              >
              </el-input>
              <el-dropdown-item
                v-for="record in townList"
                v-bind:key="record.id"
                :command="record.id"
                >{{ record.townName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="login">
          <el-image
            style="width: 15px; height: 17px; vertical-align: text-bottom"
            :src="userUrl"
          ></el-image>
          <el-button v-if="!userInfo" class="login-show" v-on:click="toggleLogin()">登录</el-button>
          <el-dropdown v-if="userInfo" class="login-show">
            <a>{{ userInfo.opertorName }}</a>
            <el-dropdown-menu class="logout-menu" slot="dropdown">
              <el-dropdown-item>
                <div @click="logoutReq" title="退出登录">
                  <i class="iconfont icontuichudenglu" style="font-size: 14px" />
                  退出登录
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="loginModel">
      <el-dialog :visible.sync="loginModalVisible" :show-close="false" :before-close="closeDialog">
        <div style="margin-top: 61px">
          <el-input placeholder="请输入您的手机号码" v-model="formData.phone"
            ><el-image style="width: 19px" :src="loginName" slot="prefix"></el-image
          ></el-input>
          <el-input placeholder="请输入您的密码" v-model="formData.password" v-if="isVisual">
            <el-image style="width: 17px" :src="loginPwd" slot="prefix"></el-image>
            <el-image
              style="width: 27px"
              :src="visual"
              slot="suffix"
              @click="changeVisual"
            ></el-image>
          </el-input>
          <el-input placeholder="请输入您的密码" v-model="formData.password" v-else type="password">
            <el-image style="width: 17px" :src="loginPwd" slot="prefix"></el-image>
            <el-image
              style="width: 27px"
              :src="noVisual"
              slot="suffix"
              @click="changeVisual"
            ></el-image>
          </el-input>
        </div>
        <div slot="title" class="dialog-title">
          <div style="margin-bottom: 10px">用户登录</div>
          <div class="title-underline"></div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="loginSubmit" :loading="btnLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { isDev } from '@/constants'
import userUrl from './assets/user.png'
import loginName from './assets/login-name.png'
import loginPwd from './assets/login-pwd.png'
import visual from './assets/visual.png'
import noVisual from './assets/no-visual.png'
import envConfig from '@/constants/env'
let env = process.env.API_ENV || 'dev'
const { openUrl } = envConfig[env]
const { futureUrl } = envConfig[env]
const logo_url = require('../assets/image/logo_banner3.png')
const logo_url_taizhou = require('../assets/image/logo_taizhou@2x.png')

export default {
  data() {
    return {
      taizhouFlag: false,
      huangyanFlag: false,
      btnLoading: false,
      haishuFlag: false,
      // loginModalVisible: false,
      isVisual: false,
      visual,
      noVisual,
      loginName,
      // logoUrl: 'https://gt-toolbox.oss-cn-beijing.aliyuncs.com/gt-toolbox/785880a7-0017-44de-b93d-64e51043c974.png',
      logoUrl: logo_url,
      loginPwd,
      userUrl,
      openUrl,
      futureUrl,
      formData: {
        phone: isDev ? 'yuhaixiang' : '',
        password: isDev ? 'Y123456' : ''
      },
      passwordVisible: false,
      townName:
        this.getTownName(localStorage.getItem('townId')) || localStorage.getItem('townName'),
      searchtown: ''
    }
  },
  computed: {
    ...mapState({
      loginModalVisible: state => state.login.loginModalVisible,
      userInfo: state => state.user.userInfo,
      townList: state => state.user.townList,
      townId: state => state.user.townId,
      logining: state => state['@@loading'].effects['login/login'],
      channelByCode: state => state.home.channelByCode,
      code: state => state.home.code
    })
  },
  watch: {
    userInfo(after) {
      if (after) {
        this.fetchTownList()
      }
    },
    townId(after) {
      this.townName = this.getTownName(after)
    },
    townList(after) {
      if (after && after.length) {
        if (this.getTownName(this.townId)) {
          this.townName = this.getTownName(this.townId)
        }
        if (after.length) {
          if (this.townId) {
            const town = after.filter(item => item.id.toString() === this.townId.toString())
            if (town.length) {
              this.updatePublishType(town[0].publishType)
            }
          } else {
            const firstTown = after[0]
            this.updateTownId(firstTown.id)
            this.updatePublishType(firstTown.publishType)
          }
        }
      }
    },
    loginModalVisible() {
      this.formData.password = ''
    },
    '$route.query': {
      handler() {
        this.changeTotal()
      }
    }
  },
  methods: {
    ...mapMutations('login', ['toggleLoginModalVisible']),
    ...mapMutations('user', ['updateTownId', 'updatePublishType', 'updateUserInfo']),
    ...mapActions('login', ['login', 'logout']),
    ...mapActions('user', ['fetchTownList']),
    validate() {
      const { phone, password } = this.formData
      if (!phone) {
        this.$message.error('请输入用户名')
        return false
      }
      if (!password) {
        this.$message.error('请输入密码')
        return false
      }
      return true
    },
    toggleLogin() {
      if (!this.logining) {
        this.toggleLoginModalVisible()
      }
    },
    closeDialog() {
      this.toggleLoginModalVisible()
    },
    getTownName(id) {
      const { townList } = this
      if (id && townList && townList.length) {
        const filter = townList.filter(item => item.id.toString() === id.toString())
        if (filter.length) {
          return filter[0].townName
        }
      }
      return null
    },
    handleTownSwitch(id) {
      const { townList } = this
      const town = townList.filter(item => item.id === id)
      this.updateTownId(id)
      this.updatePublishType(town[0].publishType)
    },
    togglePasswordVisible() {
      this.passwordVisible = !this.passwordVisible
    },
    submit() {
      const { phone, password } = this.formData
      if (!this.validate()) {
        return
      }
      this.login({
        account: phone,
        password
      })
    },
    handleSubmitFormKeyup(e) {
      if (e && e.keyCode === 13) {
        this.submit()
      }
    },
    goHome() {
      if (this.taizhouFlag) {
        this.$router.replace('/yiwu')
      } else if (this.huangyanFlag) {
        this.$router.replace('/huangyan')
      } else if (this.haishuFlag) {
        this.$router.replace('/haishu')
      } else {
        this.$router.push('/')
      }
    },
    changeVisual() {
      this.isVisual = !this.isVisual
    },
    loginSubmit() {
      var that = this
      that.btnLoading = true
      if (!that.formData.phone) {
        that.showAlert('请输入手机号~')
        return false
      }
      if (!that.formData.password) {
        that.showAlert('请输入密码~')
        return false
      }
      var params = {
        account: that.formData.phone,
        password: that.formData.password
      }
      that.$axios
        .post('/operator/login', params)
        .then(res => {
          if (res.data && res.code === '0') {
            this.toggleLoginModalVisible()
            this.updateUserInfo(res.data)
            window.localStorage.setItem('userInfoApp', JSON.stringify(res.data))
            window.localStorage.setItem('townId', res.data.townId)
            window.localStorage.setItem('townName', res.data.townName)
            window.localStorage.setItem('publishType', res.data.publishType)
            window.localStorage.setItem('access-token', res.data.accessToken)
            window.localStorage.setItem('refreshToken', res.data.refreshToken)
            this.$router.go(0)
          } else {
            this.showAlert(res.msg)
          }
          that.btnLoading = false
        })
        .catch(function(eMsg) {
          that.btnLoading = false
        })
    },
    toPartner() {
      if (this.taizhouFlag || this.huangyanFlag) {
        window.open(this.openUrl + 'doc', '_blank')
      } else if (this.haishuFlag) {
        window.open('https://wlsq.jst.zj.gov.cn/zlwlsq/openplatform/', '_blank')
      } else {
        // 合作伙伴招募
        // window.open(this.openUrl + 'partner', '_blank')
        // 生态伙伴专区
        window.open(this.futureUrl + '/partner', '_blank')
      }
    },
    showAlert: function(cont) {
      this.$message.error({ message: cont, duration: 3000 })
    },
    searchTownname(val) {
      if (val) {
        this.fetchTownList({ townName: val })
      } else {
        this.fetchTownList()
      }
    },
    dropDownVisible(val) {
      if (!val) {
        this.searchtown = ''
        this.searchTownname()
      }
    },
    // 退出登录
    logoutReq() {
      let witchApp = {
        taihzou: this.taizhouFlag,
        huangyan: this.huangyanFlag,
        haishu: this.haishuFlag
      }
      this.logout(witchApp)
    },
    changeTotal() {
      const flag =
      (this.$route.query.taizhou && this.$route.query.taizhou === 'true') ||
        this.$route.meta.pageName === '台州专区'
      const flag2 =
        (this.$route.query.huangyan && this.$route.query.huangyan === 'true') ||
        this.$route.meta.pageName === '黄岩专区'
      const flag3 =
        (this.$route.query.yiwu && this.$route.query.yiwu === 'true') ||
        this.$route.meta.pageName === '义乌专区'
      const flag4 =
        (this.$route.query.haishu && this.$route.query.haishu === 'true') ||
        this.$route.meta.pageName === '海曙专区'
      this.taizhouFlag = flag || flag3 || this.$route.query.tab === 'second'
      this.huangyanFlag = flag2 || this.$route.query.tab === 'second'
      this.haishuFlag = flag4
      if (this.taizhouFlag) {
        // this.logoUrl = 'https://gt-toolbox.oss-cn-beijing.aliyuncs.com/gt-toolbox/6d75b22a-1839-4e0a-ac32-ebfc9a5473ef.png'
        this.logoUrl = logo_url_taizhou
        document.title = '义乌市全域未来社区/乡村服务应用商城'
      } else if (this.huangyanFlag) {
        this.logoUrl =
          'https://gt-toolbox.oss-cn-beijing.aliyuncs.com/gt-toolbox/45eb2e29-0f13-49b2-aad8-813a9db9fcfd.png'
        document.title = '黄岩服务应用商城'
      } else if (this.haishuFlag) {
        this.logoUrl =
          'https://filestorage.gtdreamlife.com/test/16703919532904b65a74c7765442daa13044e284e2dc6.png'
        document.title = '海曙在线服务应用商城'
      } else {
        this.logoUrl = logo_url
        document.title = '绿城未来数智｜未来社区服务应用商城'
      }
    }
  },
  created() {
    this.changeTotal()
    this.fetchTownList()
    this.townName = this.getTownName(localStorage.getItem('townId'))
  }
}
</script>

<style lang="less" scoped>
.header-wrapper {
  width: 100%;
  background: #ffffff;
  .header {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-img {
      height: 24px;
      cursor: pointer;
      /deep/ .el-image__inner {
        width: auto;
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      a {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
        font-family: PingFangSC-Medium;
      }
    }
  }
}
.recruit,
.login {
  display: inline-block;
}
.recruit {
  margin-right: 50px;
  font-size: 16px;
  font-family: PingFangSC-Medium;
  .el-button {
    background-color: #000;
    color: #fff;
    border-color: #000;
    border-radius: 0;
    &:hover,
    &:focus {
      background-color: #000;
      color: #fff;
      border-color: #000;
    }
  }
}

.login {
  height: 40px;
  line-height: 40px;
  .login-show {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    font-family: PingFangSC-Medium;
    padding: 0;
    display: inline-block;
    border: 0;
    &:hover,
    &:active,
    &:focus {
      background-color: #fff;
    }
  }
}

.black-bg {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 500;
  transition: all 0.5s;
}

.loginModel {
  .title-underline {
    height: 6px;
    width: 58px;
    background-color: #0091ff;
    margin-left: 164px;
  }
}
</style>

<style lang="less">
.loginModel {
  .el-dialog {
    height: 402px;
    width: 427px;
  }
  .el-dialog__header {
    padding: 25px 20px 0;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #000000;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-input .el-input__inner {
    width: 339px;
    height: 60px;
    margin-left: 43px;
    border: 0px;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #000;
    letter-spacing: 0;
    padding-left: 42px;
    border-radius: 0;
    border-bottom: 2px solid #d1d1d1;
    &::-webkit-input-safebox-button {
      display: none;
    }
    &:active,
    &:focus {
      border-bottom: 2px solid #0091ff;
    }
  }
  .el-input:nth-child(2) {
    margin-top: 31px;
  }
  .el-input__prefix {
    margin-left: 50px;
  }
  .el-input__suffix {
    margin-right: 52px;
  }
  .el-dialog__footer {
    padding: 0;
    margin-top: 41px;
    margin-left: 44px;
    width: 339px;
    height: 40px;
    .el-button {
      width: 339px;
      height: 40px;
      background: #2795e9;
      padding: 0;
      span {
        width: 32px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
      }
    }
  }
  .el-image {
    vertical-align: text-bottom;
    margin-top: 19px;
  }
}

.el-message--error {
  background-color: #fff;
  border-color: #fff;
}
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background-color: #f3f9fe;
  color: #2795e9;
}
.search-dropdown-menu {
  height: 371px;
  overflow: hidden;
  overflow-y: scroll;
  .el-dropdown-menu__item {
    line-height: 48px;
  }
  .el-input > input {
    border: none;
  }
  // .el-input>input::-webkit-input-placeholder {
  //   color: #606266;
  // }
}
.logout-menu {
  .el-dropdown-menu__item {
    line-height: 48px;
  }
}
.el-popper {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue